export default [
    'paid',
    'unpaid',
    'partially_paid',
]
